import React from 'react';
import { useIrzFacilities } from '../../irz-facility/irz-facilities-api';
import { FormPanel, FormAutocomplete } from '@eas/common-web';
import { dictionaryLabelMapper } from '../../../components/form/mappers/label-mappers';
import { HelpLabel } from '../../../components/help/help-label';

export function StepMainFacilityContent() {
  const irzFacilities = useIrzFacilities();

  return (
    <FormPanel label="Vyplňte">
      <FormAutocomplete
        name="mainFacility"
        label={
          <HelpLabel
            label="Provozovna"
            code="IRZ_FACILITY_SPLIT_MAIN_FACILITY"
          />
        } // Provozovna, která bude rozdělena
        source={irzFacilities}
        labelMapper={dictionaryLabelMapper}
        tooltipMapper={dictionaryLabelMapper}
      />
    </FormPanel>
  );
}
